export const GET_STORE_CATEGORIES = 'getStoreCategories'